
























































































import { Component, Vue, Watch } from "vue-property-decorator";
import Loading from "vue-loading-overlay";
import Paging from "@/shared/components/Paging.vue";
import { DATA } from "@/config/data";
import { APP_CONFIG } from "@/config/app-config";
import { TransitionModel, SummaryTransitionModel } from "@/models/transition";

import ListTransition from "./components/ListTransition.vue";
import FilterBox from "./components/FilterBox.vue";

import authService from "@/services/auth-services";
import transitionServices from "@/services/transition-services";
import commonService from "@/services/common-services";
@Component({
  components: {
    ListTransition,
    FilterBox,
    Loading,
    Paging,
  },
})
export default class ListItem extends Vue {
  private filterProp = {
    selectedStatus: { value: -1, name: "Tất cả", color: "#fff" },
    searchText: "",
  };
  private pageSettings = {
    rowPerPage: 15,
    pageSize: 6,
    pageIndex: 1,
    total: 0,
  };

  private summaryOrder: SummaryTransitionModel = new SummaryTransitionModel();
  private listItem: TransitionModel[] = [];
  private isLoading = false;
  private isShowModal = false;
  private customerInfo: any = {};
  private newOrder: any = {};
  private listTransactions = "";

  get userInfo() {
    return this.$store.state[APP_CONFIG.stateKey.authStore].userInfo;
  }

  get warehouse() {
    let tmp = this.$store.state[APP_CONFIG.stateKey.commonStore].warehouse;
    return tmp ? tmp.filter((p) => p.StoreType === 1 && !p.IsHidden) : null;
  }

  get chinaStore() {
    let tmp = this.$store.state[APP_CONFIG.stateKey.commonStore].chinaStore;
    return tmp ? tmp.filter((p) => p.StoreType === 1 && !p.IsHidden) : null;
  }

  get showMenu() {
    return this.$store.state[APP_CONFIG.stateKey.commonStore].showMenuLeft;
  }

  private async getWarehouse() {
    const result = await commonService.getWarehouse();
    if (result && result.status === 200) {
      (window["getApp"] as any).$emit("SET_WAREHOUSE", result.data.data);
    }
  }

  private async getChinaStore() {
    const result = await commonService.getChinaStore();
    if (result && result.status === 200) {
      (window["getApp"] as any).$emit("SET_CHINASTORE", result.data.data);
    }
  }

  private async created() {
    await this.getCustomersInfo();
    if (!this.warehouse) {
      await this.getWarehouse();
    }
    if (!this.chinaStore) {
      await this.getChinaStore();
    }
    this.loadData();
  }

  private async getCustomersInfo() {
    const result = await authService.customersInfo(this.userInfo.userId);
    if (result && result.status === 200) {
      this.customerInfo = result.data.data || {};
      (window["getApp"] as any).$emit(
        "APP_SET_CUSTOMER_INFO",
        result.data.data || {}
      );
    }
  }

  private async loadData() {
    this.isLoading = true;
    this.pageSettings.total = 0;
    const filters: any = this.onBuildFilter();
    this.summaryOrder = new SummaryTransitionModel();
    const result = await transitionServices.getList(
      this.pageSettings.pageIndex,
      this.pageSettings.rowPerPage,
      filters.filters,
      filters.quickFilters,
      true
    );
    this.isLoading = false;
    if (result && result.data && result.data.status === 200) {
      const tmpListTransition: TransitionModel[] = [];
      this.pageSettings.total = result.data.total;
      this.summaryOrder = {
        TotalStatusAll: result.data.summary.TotalStatusAll || 0,
        TotalStatus0: result.data.summary.TotalStatus0 || 0,
        TotalStatus1: result.data.summary.TotalStatus1 || 0,
        TotalStatus2: result.data.summary.TotalStatus2 || 0,
        TotalStatus3: result.data.summary.TotalStatus3 || 0,
        TotalStatus4: result.data.summary.TotalStatus4 || 0,
        TotalStatus5: result.data.summary.TotalStatus5 || 0,
        TotalStatus13: result.data.summary.TotalStatus13 || 0,
      };

      for (const item of result.data.data) {
        const transition = new TransitionModel();
        transition.ID = item.ID;
        transition.Status = item.Status;
        transition.TransactionCode = item.TransactionCode;
        transition.Weight = item.Weight;
        transition.Length = item.Length;
        transition.Width = item.Width;
        transition.Height = item.Height;
        transition.Volume = item.Volume;
        transition.StoreCNImportDate = item.StoreCNImportDate;
        transition.StoreCNExportDate = item.StoreCNExportDate;
        transition.StoreVNImportDate = item.StoreVNImportDate;
        transition.StoreVNExportDate = item.StoreVNExportDate;
        transition.ProductName = item.ProductName;
        transition.ProductAmount = item.ProductAmount;
        transition.ProductNumber = item.ProductNumber;
        transition.GuaranteeType = item.GuaranteeType;
        transition.IsGuarantee = item.IsGuarantee;
        transition.GuaranteeAmountVND = item.GuaranteeAmountVND;
        transition.CheckFeeType = item.CheckFeeType;
        transition.IsCheck = item.IsCheck;
        transition.CheckFeeVND = item.CheckFeeVND;
        transition.IsFragileGoods = item.IsFragileGoods;
        transition.FragileFeeVND = item.FragileFeeVND;
        transition.CreatedDate = item.CreatedDate;
        transition.FeeShip = item.FeeShip;
        transition.IsFoam = item.IsFoam;
        transition.FoamFeeVND = item.FoamFeeVND;
        transition.TotalAmount = item.TotalAmount;
        transition.PriceAmount = item.PriceAmount;

        let parsedPackages: any[] = [];
        if (item.Packages) { // Giả sử 'Packages' là trường JSON string từ API
            try {
                const tempPackages = JSON.parse(item.Packages);
                if (Array.isArray(tempPackages)) {
                    parsedPackages = tempPackages;
                } else {
                    console.warn('Parsed packages is not an array:', tempPackages, `for transition ID: ${item.ID}`);
                }
            } catch (e) {
                console.error('Failed to parse Packages JSON:', item.Packages, `for transition ID: ${item.ID}`, e);
            }
        }
        transition.Packages = parsedPackages; // Thêm thuộc tính 'packages' đã parse

        transition.TotalPaidAmount = item.TotalPaidAmount;
        transition.TotalRemainAmount = item.TotalRemainAmount;
        transition.receivePlaceDetail = this.warehouse
          ? this.warehouse.find((p) => p.ID === item.ReceivePlaceID)
          : "";
        transition.chinaStoreDetail = this.chinaStore
          ? this.chinaStore.find((p) => p.ID === item.ChinaStoreID)
          : "";
        transition.statusDetail = DATA.billOfLadingStatus.find(
          (x) => x.value === item.Status
        ) || { value: 0, name: "", color: "#3b4354" };
        tmpListTransition.push(transition);
      }
      this.listItem = tmpListTransition;
    }
  }

  private onBuildFilter() {
    const paramsFilter: any = {
      filters: [],
      quickFilters: [],
    };
    paramsFilter.filters.push({
      column: "IsEcommerce",
      value: 1,
      condition: "equal",
    });
    if (this.filterProp.selectedStatus.value !== -1) {
      paramsFilter.filters.push({
        column: "Status",
        value: this.filterProp.selectedStatus.value,
        condition: "equal",
      });
    }

    if (
      this.filterProp.searchText !== null &&
      this.filterProp.searchText !== undefined &&
      this.filterProp.searchText !== ""
    ) {
      paramsFilter.quickFilters.push({
        column: "TransactionCode",
        value: this.filterProp.searchText,
        condition: "contain",
      });
      paramsFilter.quickFilters.push({
        column: "ID",
        value: this.filterProp.searchText,
        condition: "contain",
      });
      paramsFilter.quickFilters.push({
        column: "OrderID",
        value: this.filterProp.searchText,
        condition: "contain",
      });
    }

    return paramsFilter;
  }

  private onFilterChanged(data: any) {
    this.filterProp.selectedStatus = data.status;
    this.filterProp.searchText = data.searchText;
    this.pageSettings.pageIndex = 1;
    this.loadData();
  }

  private onChangePage(data: any) {
    this.pageSettings.pageIndex = data;
    this.loadData();
  }

  private openNewDialog() {
    this.isShowModal = true;
    this.newOrder = {
      ChinaStoreID: 19,
      ReceivePlaceID: this.userInfo.ReceivePlaceID,
      ListTransactionCode: [],
    };
    this.listTransactions = "";
  }

  private async createNewItems() {
    if (
      !this.newOrder.ChinaStoreID ||
      !this.newOrder.ReceivePlaceID ||
      this.listTransactions === ""
    ) {
      Vue.notify({
        group: "foo",
        type: "error",
        title: "Thông báo!",
        text: "Hãy nhập đầy đủ thông tin!",
      });
      return;
    }
    const listTransactionCode = this.listTransactions.split(/[\s,;]+/);
    this.newOrder.ListTransactionCode = listTransactionCode;
    this.newOrder.CustomerID = this.userInfo.userId;
    this.newOrder.IsEcommerce = 1;
    this.isLoading = true;
    transitionServices.createNewItems(this.newOrder).then((result) => {
      if (result && result.status === 200) {
        Vue.notify({
          group: "foo",
          type: "success",
          title: "Thông báo!",
          text: "Tạo mới thành công!",
        });
        this.loadData();
      } else {
        Vue.notify({
          group: "foo",
          type: "error",
          title: "Thông báo!",
          text: "Tạo mới không thành công!",
        });
      }
      this.isShowModal = false;
    });
  }
}
